module.exports = __webpack_public_path__ + "img/uruguay.57ef930c.svg";